import { navigate } from "gatsby"
import { SoundFinishControl } from "../Interface/index"
import { useCreateAnalyticsEvent } from "../hooks/useCreateAnalyticsEvent"
import Config from "../Config"

const { AnalyticsEvent } = Config

export const useFinishSound = (): SoundFinishControl => {
  const analyticsEvent = (label: string) => useCreateAnalyticsEvent(label)
  const onFinishSound = () => {
    const result = window.confirm("クラスを中断しますか？")
    result && navigate("/")
    analyticsEvent(AnalyticsEvent.FinishSound)
  }

  return {
    onFinishSound,
  }
}
